//TODO reuse emailRegex
export default /^\s*[A-Z0-9](\.?[A-Z0-9_-])*@[A-Z0-9-]+(\.[A-Z]{2,})+\s*(,\s*[A-Z0-9](\.?[A-Z0-9_-])*@[A-Z0-9-]+(\.[A-Z]{2,})+\s*)*$/i;